import { defineStore } from 'pinia';

// Pinia replacement for the legacy Vuex CurrentUser module.
// Same getter signatures so call sites only swap their import / accessor:
//   getCurrentUser, getCurrentUserId, getCurrentUserRoles, currentUserHasRole
// `setCurrentUser` is now an action (was a Vuex mutation) — same arg.
export const useCurrentUserStore = defineStore('currentUser', {
    state: () => ({
        currentUser: null
    }),
    getters: {
        getCurrentUser: state => state.currentUser,
        getCurrentUserId: state => state.currentUser?.profile?.sub?.split(':')[1],
        getCurrentUserRoles: state =>
            state.currentUser ? state.currentUser.profile.role : [],
        currentUserHasRole: state => role => {
            if (state.currentUser && state.currentUser.profile.role) {
                const userRoles = state.currentUser.profile.role;
                const roles = Array.isArray(userRoles) ? userRoles : [userRoles];
                return roles.includes(role);
            }
            return false;
        }
    },
    actions: {
        setCurrentUser(value) {
            this.currentUser = value;
        }
    }
});
